import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ErrorHandler, APP_INITIALIZER } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ThemeModule } from './core/theme.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialComponentsModule } from './material-components.module';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { CompletedOpportunitiesComponent } from './modules/completed-opportunities/completed-opportunities.component';
import { StartApplicationComponent } from './modules/start-application/start-application.component';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { CustomDateAdapter } from './modules/users/custom-date-adapter';
import { UserNotificationComponent } from './modules/user-notification/user-notification.component';
import { UserNotificationPopupComponent } from './modules/user-notification/user-notification-popup/user-notification-popup.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSortModule } from '@angular/material/sort';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { Integrations } from '@sentry/tracing';
// import { NgImageSliderModule } from 'ng-image-slider';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { AuthGuard } from './route-guard/auth-guard.service';
import { MatTableModule } from '@angular/material/table';
import { HeaderNotificationPopupComponent } from './modules/user-notification/header-notification-popup/header-notification-popup.component';
import { MessagePortalComponent } from './modules/message-portal/message-portal.component';
import { NewMessagePopupComponent } from './modules/message-portal/new-message-popup/new-message-popup.component';
import { IsOpportunityGuard } from './route-guard/is-opportunity.guard.service';
import { SelectedMessageComponent } from './modules/message-portal/selected-message/selected-message.component';
import { ConfirmationPromptComponent } from './modules/repetaed-component/confirmation-prompt/confirmation-prompt.component';

// import { IsAccountantGuard } from './route-guard/is-accountant-guard.service';
// import { IsNotAccountantGuard } from './route-guard/is-not-accountant-guard.service';
// import { MatIconRegistry } from "@angular/material/icon";
// import { DomSanitizer } from "@angular/platform-browser";

Sentry.init({
  dsn: 'https://af44223d136e4d679cd25884b0c5c341@o1065768.ingest.sentry.io/6059529',
  integrations: [
    new Integrations.BrowserTracing({
      tracingOrigins: ['localhost', 'https://yourserver.io/api'],
      routingInstrumentation: Sentry.routingInstrumentation,
    }),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

@NgModule({
  declarations: [
    AppComponent,
    CompletedOpportunitiesComponent,
    StartApplicationComponent,
    UserNotificationComponent,
    UserNotificationPopupComponent,
    HeaderNotificationPopupComponent,
    MessagePortalComponent,
    NewMessagePopupComponent,
    SelectedMessageComponent,
    ConfirmationPromptComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    ThemeModule,
    BrowserAnimationsModule,
    MaterialComponentsModule,
    ReactiveFormsModule,
    MatSortModule,
    // NgImageSliderModule,
    NgxSkeletonLoaderModule,
    MatTableModule,
    // MatIconRegistry
  ],
  exports: [MaterialComponentsModule],
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: true,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },

    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: DateAdapter, useClass: CustomDateAdapter },
    CurrencyPipe,
    AuthGuard,
    IsOpportunityGuard,
    // IsAccountantGuard,
    // IsNotAccountantGuard,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  // constructor(
  //   private matIconRegistry: MatIconRegistry,
  //   private domSanitizer: DomSanitizer,
  //   private customIconService: CustomIconService
  //  ) {
  //   this.matIconRegistry.addSvgIcon(
  //     "logo",
  //     this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/logo.svg")
  //   );
  // }
}
